import { useEffect, useRef, useState } from "react";
import styles from "./CreateCheckList.module.css";
import step1Filled from "../../../assets/stepone.png";
import { AntdDropdown, AntdInput, AntdSubmit } from "../../../components";
import { Button, Collapse, List } from "antd";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import InputField from "../../../components/input/InputField";
import { AiOutlinePlus } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import pickImage from "../../../assets/pickImage.png";
import { useDispatch } from "react-redux";
import AlertAction from "../../../store/Actions/AlertActions";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";

const CreateCheckList = () => {
  const navigate = useNavigate();
  const [checklistName, setchecklistName] = useState();
  const [ItemName, setItemName] = useState();
  const [ItemImage, setItemImage] = useState();
  const [MultipleItems, setMultipleItems] = useState([]);
  const hiddenFileInput = useRef(null);
  const [Toggle, setToggle] = useState(true);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const { state } = useLocation();
  const data = state?.data;
  const jobData = state?.screen == "AcceptWorkOrder" ? state?.jobData : null;
  const screen = state?.screen == "AcceptWorkOrder" ? true : false;
  console.log("jobData", jobData);
  useEffect(() => {
    getCleaner();
    getLanguage();
  }, []);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [CheckListName, setCheckListName] = useState("");
  const [AddItem, setAddItem] = useState("");
  const [itemDescription, setItemDescription] = useState("");
  const [AddedItem, setAddedItem] = useState([]);
  const [MultipleLocations, setMultipleLocations] = useState([]);
  const [RequestNo, setRequestNo] = useState(
    screen ? jobData?.data.request_no : null
  );
  // const [pickImage, setpickImage] = useState(null);
  const [CameraAndLibraryModalVisible, setCameraAndLibraryModalVisible] =
    useState(false);

  const [RefreshList, setRefreshList] = useState(false);
  const [CleanerList, setCleanerList] = useState([]);
  const [selectedCleaner, setselectedCleaner] = useState(
    screen ? data?.SelectedCleaner : null
  );
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const onPressAddItem = () => {
    if (!AddItem) {
      dispatch(
        AlertAction.ShowAlert({ type: "error", message: t("Type Item First.") })
      );
      // Alert.alert('Note', t('Type Item First.'));
    } else if (!itemDescription) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: t("Type Item Description."),
        })
      );
      // Alert.alert('Note', t('Type Item Description.'));
    } else {
      AddedItem.push({
        itemName: AddItem,
        id: AddedItem.length,
        description: itemDescription,
        image: ItemImage,
      });
      setAddItem("");
      setItemDescription("");
      setItemImage();
      // eslint-disable-next-line no-unused-expressions
      hiddenFileInput.current.value = "";
      setRefreshList(!RefreshList);
    }
  };

  const getCleaner = () => {
    let data = {
      role: "cleaner",
    };
    dispatch(CustomerMiddleware.getUsersByRole(data))
      .then((data) => {
        setCleanerList(data?.data);
        if (screen) {
          cleanersJobLocations(selectedCleaner);
        }
      })
      .catch((err) => console.log(err));
  };

  const cleanersJobLocations = (id) => {
    let locationId = data?.selectedLocation;
    let userData = {
      id: id,
      pagination: "no",
      next_page_url: undefined,
    };
    dispatch(CustomerMiddleware.cleanersJobLocations(userData))
      .then((data) => {
        console.log("cleanersJobLocations", data);
        setMultipleLocations(data?.data);
        // setRequestNo(data?.request_no);
        if (screen) {
          setSelectedLocation(locationId);
          const searchLocation = data?.data.findIndex(
            (item) => item?.location?.id == locationId
          );
          setSelectedLocationName(
            data?.data[searchLocation]?.location?.address
          );
          // let locationName = MultipleLocations[searchLocation]?.location?.address;
        }
      })
      .catch((err) => console.log(err));
  };

  const CreateChecklist = () => {
    if (!CheckListName) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Please Enter Checklist Name",
        })
      );
    } else if (!selectedCleaner) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Please Select Cleaner Name",
        })
      );
    } else if (!selectedLocation) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Please Select Location",
        })
      );
    } else if (AddedItem.length == 0 && (!AddItem || !itemDescription)) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Item name and description required",
        })
      );
    } else {
      if (AddedItem.length == 0 && (AddItem || itemDescription)) {
        AddedItem.push({
          itemName: AddItem,
          id: AddedItem.length,
          description: itemDescription,
          image: ItemImage,
        });
      } else if (AddItem || itemDescription) {
        AddedItem.push({
          itemName: AddItem,
          id: AddedItem.length,
          description: itemDescription,
          image: ItemImage,
        });
      }
      let response = {
        CheckListName: CheckListName,
        Id: screen ? jobData?.data?.id : selectedLocation,
        data: AddedItem,
      };
      dispatch(CustomerMiddleware.CreateChecklist(response))
        .then((data) => {
          dispatch(
            AlertAction.ShowAlert({ type: "success", message: data?.message })
          );
          if (screen) {
            navigate("/contractorHome/Checklist");
          } else {
            navigate(-2);
          }
        })

        .catch((err) => console.log(err));
    }
  };

  const onPressRemoveItem = (index, id) => {
    AddedItem.splice(index, 1);
    setAddedItem(AddedItem);
    setRefreshList(!RefreshList);
  };

  const { Panel } = Collapse;
  const renderItem = (item, index) => {
    return (
      <Collapse size="large" bordered={false} className={styles.dropdown}>
        <Panel
          showArrow={false}
          header={
            <div className={styles.headerMainCont}>
              <div className={styles.headerSubCont}>
                <div>
                  <IoIosArrowUp className={styles.arrow_icon} color="#ffff" />
                </div>
                <div className={styles.headerSubDiv}>
                  <text className={styles.text_x} style={{ marginLeft: "1%" }}>
                    {item?.itemName}
                  </text>
                </div>
              </div>
              <div>
                <MdDelete
                  size={25}
                  onClick={() => onPressRemoveItem(index, item?.id)}
                  className={styles.delIcon}
                />
              </div>
            </div>
          }
          key="1"
          className={styles.dropdown_header}
        >
          <div className={styles.flexC}>
            <div style={{ width: "80%", overflowWrap: "break-word" }}>
              <text className={styles.text_x}>{item?.description}</text>
            </div>
            {item?.image ? (
              <img
                src={URL.createObjectURL(item?.image)}
                className={styles.dropdown_item_image}
              />
            ) : null}
          </div>
        </Panel>
      </Collapse>
    );
  };

  const setLocation = (val) => {
    console.log("setLocation");
    const searchLocation = MultipleLocations.findIndex(
      (item) => item.request_no == val
    );
    let locationName =
      MultipleLocations[searchLocation]?.location?.address;
    let locationVal = MultipleLocations[searchLocation]?.id;
    setSelectedLocation(locationVal);
    setSelectedLocationName(locationName);
  };

  const searchCleaner = CleanerList.findIndex(
    (item) => item.id == data?.SelectedCleaner
  );
  let cleanerName = CleanerList[searchCleaner]?.name;

  return (
    <div className={styles.CreateCheckList_mainCon}>
      <div className={styles.CreateCheckList_heading}>
        <h1>Create Checklist</h1>
      </div>
      <div className={styles.CreateCheckList_content}>
        <div className={styles.CreateCheckList_Subcontent}>
          <div className={styles.CreateCheckList_rowOne}>
            <div className={styles.CreateCheckList_input}>
              {screen ? (
                <AntdInput
                  placeholder={cleanerName}
                  name={"cleaner_name"}
                  label="Cleaner Name"
                  value={cleanerName}
                  disabled
                />
              ) : (
                <AntdDropdown
                  placeholder={"Choose Cleaner"}
                  name={"cleaner_name"}
                  label={"Cleaner Name"}
                  onChange={(val) => {
                    setselectedCleaner(val);
                    cleanersJobLocations(val);
                    setRequestNo();
                    setSelectedLocation();
                    setSelectedLocationName();
                  }}
                  options={CleanerList?.map((item) => {
                    return { value: item?.id, option: item?.name };
                  })}
                />
              )}
            </div>
            <div className={styles.CreateCheckList_input}>
              {screen ? (
                <AntdInput
                  placeholder={RequestNo}
                  name={"Request No"}
                  label="Request No"
                  value={cleanerName}
                  disabled
                />
              ) : (
                <AntdDropdown
                  placeholder={RequestNo ? RequestNo : "Choose Work Order"}
                  name={"work_order"}
                  label={"Work Order"}
                  selectedValue={RequestNo}
                  onChange={(val) => {
                    setRequestNo(val);
                    setLocation(val);
                  }}
                  options={MultipleLocations?.map((item) => {
                    return {
                      value: item?.request_no,
                      option: item?.request_no,
                    };
                  })}
                />
              )}
            </div>
          </div>
          <div className={styles.CreateCheckList_rowOne}>
            <div className={styles.CreateCheckList_dropdown}>
              {screen ? (
                <AntdInput
                  placeholder={selectedLocationName}
                  name={"location"}
                  label="Location"
                  value={selectedLocationName}
                  disabled
                />
              ) : (
                <AntdInput
                  placeholder={
                    selectedLocationName
                      ? selectedLocationName
                      : "Choose Location"
                  }
                  name={"location"}
                  label="Location"
                  value={selectedLocationName}
                  disabled
                />
              )}
            </div>
            <div className={styles.CreateCheckList_input}>
              <AntdInput
                placeholder={"Checklist Name"}
                name={"Checlist_name"}
                label="Checklist Name"
                value={CheckListName}
                onChange={(e) => setCheckListName(e.target.value)}
                rules={[
                  {
                    require: true,
                    type: "text",
                    message: "Please enter checklist name",
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className={styles.wrap_input}>
          <div className={styles.flexC}>
            <AntdInput
              placeholder={"Item Name"}
              label="Add Item"
              onChange={(e) => setAddItem(e.target.value)}
              value={AddItem}
              style={{ width: "53%" }}
              rules={[
                {
                  require: true,
                  type: "text",
                  message: "Please enter checklist name",
                },
              ]}
            />
            <button className={styles.add_button} onClick={onPressAddItem}>
              <AiOutlinePlus className={styles.add_icon} />
            </button>
          </div>
        </div>

        <textarea
          placeholder={t("Item Description")}
          onChange={(e) => setItemDescription(e.target.value)}
          value={itemDescription}
          className={styles.text_box}
          rows={7}
          cols={7}
        ></textarea>
      </div>

      <div className={styles.sub_headingx}>
        <text>{t("Add Image")}</text>
      </div>

      <div className={styles.imgMainCont}>
        <div>
          <img
            src={ItemImage ? URL.createObjectURL(ItemImage) : pickImage}
            style={{ width: "100%", height: "100%" }}
          />
        </div>

        <div style={{ marginTop: "5%" }}>
          <button className={styles.image_add_button} onClick={handleClick}>
            <AiOutlinePlus className={styles.add_icon} />
          </button>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setItemImage(e.target.files[0])}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </div>
      </div>

      <List dataSource={AddedItem} renderItem={renderItem} />

      <div className={styles.button}>
        <AntdSubmit
          onClick={() => CreateChecklist()}
          on
          text={"Add Checklist"}
        />
      </div>
    </div>
  );
};
export default CreateCheckList;
